import PromiseHelper from "base/PromiseHelper";
import AjaxPageLoader from "webPage/AjaxPageLoader";
import Page from "webPage/Page";

export default class TrainingCoursesCalendar {
    constructor($calendar, $form) {
        this.$calendar = $calendar;
        this.$form = $form;

        this.activeMonth = $calendar.attr("data-month");
        this.activeFilters = this.getCurrentFilters();

        this.bindEvents();
    }

    /**
     * @param {string} html
     * @private
     */
    _updateCalendarHtml(html) {
        let $calendar = AjaxPageLoader.parse_html(html);

        this.$calendar.html($calendar.find(".js-calendar").children());
        AjaxPageLoader.fix_html(this.$calendar);
    }

    _updateFilters(filters) {
        this.$form.find("input:checkbox").prop("checked", false);

        $.each(filters, (key, values) => {

            if (!Array.isArray(values)) {
                return;
            }

            let $inputs = this.$form.find("[name='" + key + "[]']");

            $inputs.each((_, input) => {
                let $input = $(input);
                $input.prop("checked", values.indexOf($input.attr("value")) !== -1);
            });
        });
    }

    bindEvents() {
        const me = this;
        this.$calendar.on("click", ".js-show-calendar-popup", function () {
            let $this = $(this);

            $(".calendar__popup").removeClass("calendar__popup--active");
            $this.closest(".calendar__block").find(".calendar__popup").addClass("calendar__popup--active");

            return false;
        }).on("click", ".js-close-calendar-popup", function () {
            let $this = $(this);

            $this.closest(".calendar__block").find(".calendar__popup").removeClass("calendar__popup--active");

            return false;
        }).on("click", ".js-switch-month", function () {
            let $this = $(this);

            let month = $this.attr("data-month");

            me.updateCalendar(month, me.activeFilters);
            return false;
        });

        this.$form.on("submit", () => {
            $("body").removeClass("show-filters");
            this.updateCalendar(this.activeMonth, this.getCurrentFilters());

            return false;
        });

        $("body").on("click", (e) => {
            if ($(e).closest(".calendar__popup").length === 0) {
                $(".calendar__popup").removeClass("calendar__popup--active");
            }
        });

        window.onpopstate = (e) => {
            let query = Page.get_query();
            let month = query.month;
            delete query.month;

            if (!month) {
                let now = new Date;
                month = now.getFullYear() + "-" + now.getMonth();
            }

            this._updateFilters(query);
            this.updateCalendar(month, query, false);
        };
    }

    getCurrentFilters() {
        let data = this.$form.serializeJSON();
        delete data.month;

        return data;
    }

    async updateCalendar(month, filters, pushState = true) {
        let requestId = ++TrainingCoursesCalendar.REQUEST_ID;

        this.$calendar.addClass("calendar--loading");

        try {
            let query = $.extend({}, filters, {month});
            let response = await TrainingCoursesCalendar.do_request(query);
            if (requestId !== TrainingCoursesCalendar.REQUEST_ID) {
                return;
            }

            this.activeMonth = month;
            this.activeFilters = filters;

            this._updateCalendarHtml(response.calendar);

            if (pushState) {
                let queryString = $.param(query);
                // Replace encoded square brackets with non-encoded
                queryString = queryString.replace(/%5B/g, "[").replace(/%5D/g, "]");

                history.pushState({}, null, "/training-courses/calendar/?" + queryString);
            }

        } catch (e) {
            alert("An error occurred, please try again");
            console.warn(e);
        }

        this.$calendar.removeClass("calendar--loading");
    }

    static do_request(query) {
        let key = $.param(query);

        if ('undefined' === typeof TrainingCoursesCalendar.cached_requests[key]) {
            TrainingCoursesCalendar.cached_requests[key] = Ajax.get('mgts/v1', 'training-courses/calendar', query);
        }

        return PromiseHelper.delayed_promise(TrainingCoursesCalendar.cached_requests[key], 150);
    }

}

TrainingCoursesCalendar.REQUEST_ID = 0;
TrainingCoursesCalendar.cached_requests = {};
